import React, { useState } from "react";
import { CitationButton } from "./MarkDownRenderer";
import { ChatMessageStatus } from "../FpPages/Chat/types";
import { ChevronDown, ChevronRight } from "lucide-react";

interface MultipleCitationsButtonProps {
  citations: Array<{
    citationId: string;
    displayNumber: number;
  }>;
  queryId: string;
  onClick?: (citationId: string) => void;
  status?: ChatMessageStatus;
}

export const MultipleCitationsButton: React.FC<
  MultipleCitationsButtonProps
> = ({ citations, queryId, onClick, status }) => {
  const [showCitations, setShowCitations] = useState(false);

  const handleToggle = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    // Don't allow toggle while streaming
    if (status === "streaming") {
      return;
    }
    setShowCitations(!showCitations);
  };

  return (
    <span className="inline-flex items-center gap-1">
      <span
        onClick={handleToggle}
        className={`inline-flex items-center gap-0.5 px-1.5 py-0.5 text-[10px] rounded-full ${
          status === "streaming"
            ? "bg-gray-200 text-gray-400 cursor-not-allowed"
            : "bg-blue-100 hover:bg-blue-200 text-blue-900 cursor-pointer"
        } transition-colors`}
        title={
          status === "streaming"
            ? "Citations generating..."
            : `${citations.length} citations`
        }
      >
        {showCitations ? (
          <ChevronDown className="w-3 h-3" />
        ) : (
          <ChevronRight className="w-3 h-3" />
        )}
        <span className="font-medium">{citations.length} citations</span>
      </span>
      {showCitations && (
        <span className="inline-flex gap-1 flex-wrap">
          {citations.map((citation, index) => (
            <CitationButton
              key={`${citation.citationId}-${index}`}
              citationId={citation.citationId}
              queryId={queryId}
              displayNumber={citation.displayNumber}
              onClick={onClick}
              status={status}
            />
          ))}
        </span>
      )}
    </span>
  );
};
